module.exports = __webpack_public_path__ + "static/media/e9fba76dd85a7380d879e75df26c8147.e9fba76d.jpg";